import { createApp } from 'vue';
import { SearchAppsApplication } from './components/application';

export class SearchApps{
    async init({ store }) {
        const app = createApp(SearchAppsApplication);
        app.use(store);
        app.mount('.search-apps');
    }
}